<div class="field"
     [class.inline]="options?.layout === fieldSpecsLayout.inline || labelPosition === labelPositions.left"
     [class.full]="isFull">
    <h2 *ngIf="options?.title" class="form-title">{{ options.title }}</h2>
    <div class="field-label"
        *ngIf="labelPosition === labelPositions.top || labelPosition === labelPositions.left">
        <ng-container *ngTemplateOutlet="labelTemplate" ></ng-container>
    </div>
    <div *ngIf="showDescription" class="field-description">
        <field-description [description]="options?.description"
                           (clickOutside)="showDescription = !showDescription"></field-description>
    </div>
    <ngx-form-error [control]="options.formGroup.get(options.formControlName)" [template]="custom"></ngx-form-error>
    <ng-template #custom let-errors="errors">
        <div class="errors-container"
             [class.full-errors-container]="isFull"
             [class.internal-error]="isInternalError"
             [class.has-label]="hasLabel">
            <div [class.form-error]="!isFull"
                 [class.full-error]="isFull"
                 class="error"
                 *ngFor="let error of errors;"
                 [ngClass]="findError(error.failedValidation)?.class">
                <ng-container *ngIf="!isFull && !isInternalError">
                    {{findError(error.failedValidation)?.message}}
                </ng-container>
                <fa-icon *ngIf="isFull" [title]="findError(error.failedValidation)?.message" [icon]="iconExclamation"></fa-icon>
                <fa-icon *ngIf="isInternalError"
                         [title]="findError(error.failedValidation)?.message"
                         [icon]="iconExclamation"></fa-icon>
            </div>
        </div>
    </ng-template>
    <div [class.inline]="labelPosition === labelPositions.right">
        <ng-content></ng-content>
        <div class="field-label" *ngIf="labelPosition === labelPositions.right">
            <ng-container *ngTemplateOutlet="labelTemplate" ></ng-container>
        </div>
    </div>
</div>
<ng-template #labelTemplate>
    <label *ngIf="options?.label" [attr.for]="options?.formControlName" [class.with-grey-label]="options?.withGreyLabel">
        <fa-icon *ngIf="options?.labelIcon && (options.labelIcon | iconNameToDefinition)" [icon]="options.labelIcon | iconNameToDefinition"></fa-icon>
        {{ options.label }}
        <span *ngIf="options.withAsteriskIfRequired && isFieldRequired()">*</span>
    </label>
    <fa-layers *ngIf="options.description" (click)="toggleDescription()">
        <fa-icon [icon]="iconCircle" class="blue"></fa-icon>
        <fa-icon [icon]="iconQuestion" class="white" transform="shrink-5" ></fa-icon>
    </fa-layers>
</ng-template>
